import { ArrowTrendingDownIcon } from '@heroicons/react/24/outline'
import moment from 'moment'
import { ReactElement } from 'react'
import SimpleTable from 'app/components/table/SimpleTable'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import { SectionTitle } from './SectionTitle'
import type { UseVoiceAgentOpsReturn } from './useVoiceAgentOps'

type DippingScheduleRatesSectionProps = Pick<
  UseVoiceAgentOpsReturn,
  `dippingRows` | `dippingColumns` | `previousFromDate` | `previousToDate`
>

/** Locations whose schedule rate fell compared with the previous period (plan D34, D37, D38). */
export function DippingScheduleRatesSection({
  dippingRows,
  dippingColumns,
  previousFromDate,
  previousToDate,
}: DippingScheduleRatesSectionProps): ReactElement {
  const previousPeriod = `${moment.utc(previousFromDate).format(`MMM D`)} – ${moment.utc(previousToDate).format(`MMM D, YYYY`)}`

  return (
    <div className="mb-8">
      <div className="mb-1">
        <SectionTitle title="Dipping Schedule Rates" badge={`${dippingRows?.length ?? 0} Locations`} />
      </div>
      <p className="mb-3 text-body-sm text-subtle">
        {`Locations whose schedule rate is lower than in the previous period (${previousPeriod}), biggest drop first.`}
      </p>
      <SimpleTable
        activeSubpage="voice-agent-ops-dipping"
        data={dippingRows}
        columns={dippingColumns}
        enableDeepLinking={false}
        hideFooter
        emptyState={
          <TableEmptyState
            icon={<ArrowTrendingDownIcon className="h-6 w-6" />}
            title="No dipping schedule rates"
            description="Every location with new patient calls in both periods held or improved its schedule rate."
          />
        }
      />
    </div>
  )
}
